import { render, staticRenderFns } from "./PerformanceReviewEditor.vue?vue&type=template&id=7875517c&scoped=true&"
import script from "./PerformanceReviewEditor.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewEditor.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReviewEditor.vue?vue&type=style&index=0&id=7875517c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7875517c",
  null
  
)

export default component.exports